module.exports = __webpack_public_path__ + "static/media/J1.da522fda.png";